module.exports = __webpack_public_path__ + "static/findcovidtesting-019adb2c634751458112844f25f74384.png";